// Helpers for serving responsive Unsplash images.
// Strips any incoming ?... and rebuilds with a chosen width/quality.

const baseFor = (url) => url.split("?")[0];

export function unsplashUrl(url, { w = 1200, q = 70 } = {}) {
  return `${baseFor(url)}?auto=format&fit=crop&w=${w}&q=${q}`;
}

export function unsplashSrcSet(url, widths = [400, 800, 1200, 1600], q = 70) {
  return widths
    .map((w) => `${baseFor(url)}?auto=format&fit=crop&w=${w}&q=${q} ${w}w`)
    .join(", ");
}
